// src/App.js
import React, {useEffect} from 'react';
import Navigation from './Navegación/Navigation';
import AppRoutes from './AppRoutes';
import './App.css';
import {Capacitor} from '@capacitor/core';
import {StatusBar, Style} from '@capacitor/status-bar';
import { ToastProvider } from './context/ToastContext';
import { AuthProvider, useAuth } from './Auth/AuthContext';
import { FollowingProvider } from './context/FollowingContext';
import { PlanProvider } from './context/PlanContext';
import UpgradeModal from './Monetization/UpgradeModal';

const App = () => {
    const {isAuthenticated, userId, handleLogout} = useAuth();

    useEffect(() => {
        if (Capacitor.getPlatform() !== 'web') {
            StatusBar.setOverlaysWebView({overlay: false});
            StatusBar.setBackgroundColor({color: '#4e7d3a'});
            StatusBar.setStyle({style: Style.Light});
       }
   }, []);

    return (
        <>
            {isAuthenticated && <Navigation userId={userId} onLogout={handleLogout} />}
            <AppRoutes userId={userId} />
            <UpgradeModal />
        </>
    );
};

const AppWrapper = () => (
  <AuthProvider>
    <FollowingProvider>
      <PlanProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </PlanProvider>
    </FollowingProvider>
  </AuthProvider>
);

export default AppWrapper;